import ApiService, {ApiPatch} from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import ftosActionCreators from '../../ftos/action-creators';
import notificationsActionsCreator from '../../notifications/action-creators';
import oitsCommitTypes from '../commit-types';
import oits from './oits';

const oitsActionCreators = {
  assignFtoToPhase(formData) {
    const postData = { ftoGuid: formData.ftoGuid };
    const url = `/api/v1/training-phases/${formData.trainingPhaseGuid}/assign-fto`;
    return async (dispatch) => {
      dispatch(oits.setIsLoading('assignFtoToPhase'));
      const data = await ApiService.post(url, postData)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(oits.setIsLoading('assignFtoToPhase'));
      if (data) {
        dispatch(this.assignFtoToPhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },
  assignFtoToPhaseSuccess(oitResponse) {
    return (dispatch) => {
      dispatch(this.replaceOitTrainingPhase(oitResponse.data));
      dispatch(this.closeAssignFto());
    };
  },
  closeAssignFto() {
    return (dispatch) => {
      dispatch(this.setIsAssigningFtoFor(null));
    };
  },
  closePhase(phaseGuid) {
    return async (dispatch) => {
      const patch = {
        data: {status: 'completed'},
        patched: 'status',
      };
      dispatch(oits.setIsLoading('closePhase'));
      try {
        const data = await ApiService.patch(`/api/v1/training-phases/${phaseGuid}`, patch)
          .then(response => response.data)
          .catch((error) => {
            dispatch(commonActionCreators.handleApiError(error));
            dispatch(oits.setIsLoading('closePhase'));
            return Promise.reject();
          });
        dispatch(oits.setIsLoading('closePhase'));
        if (data) {
          dispatch(this.closePhaseSuccess(data));
        }
        return Promise.resolve();

      } catch (ex) {

        return Promise.resolve();
      }
    };
  },
  closePhaseSuccess(closePhaseResponse) {
    return (dispatch) => {
      dispatch(this.replaceOitTrainingPhase(closePhaseResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Phase closed'));
    };
  },
  fetchTrainingPhase(trainingPhaseGuid) {
    return async (dispatch) => {
      dispatch(oits.setIsLoading('fetchTrainingPhase'));
      const data = await ApiService.get(`/api/v1/training-phases/${trainingPhaseGuid}`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(oits.setIsLoading('fetchTrainingPhase'));
      if (data) {
        dispatch(this.fetchTrainingPhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },

  fetchTrainingPhaseSuccess(trainingPhasesResponse) {
    return (dispatch) => {
      dispatch(this.replaceOitTrainingPhase(trainingPhasesResponse.data));
    };
  },
  createNewPhase(oitGuid, phaseConfig) {
    return async (dispatch) => {
      dispatch(oits.setIsLoading('createNewPhase'));
      const data = await ApiService.post(`/api/v1/oits/${oitGuid}/training-phases`, {
        phase_config: phaseConfig
      })
      dispatch(oits.setIsLoading('createNewPhase'));
      await dispatch(this.fetchTrainingPhasesForOit(oitGuid))
    }
  },
  fetchTrainingPhasesForOit(oitGuid) {
    return async (dispatch) => {
      dispatch(oits.setIsLoading('fetchTrainingPhasesForOit'));
      const data = await ApiService.get(`/api/v1/oits/${oitGuid}/training-phases`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(oits.setIsLoading('fetchTrainingPhasesForOit'));
      if (data) {
        dispatch(this.fetchTrainingPhasesForOitSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchTrainingPhasesForOitSuccess(trainingPhasesResponse) {
    return (dispatch) => {
      dispatch(this.pushOitTrainingPhases(trainingPhasesResponse.data));
    };
  },
  openAssignFto(phaseGuid) {
    return (dispatch) => {
      dispatch(this.setIsAssigningFtoFor(phaseGuid));
      dispatch(ftosActionCreators.fetchFtos(phaseGuid));
    };
  },
  openPhase(phaseGuid) {
    return async (dispatch) => {
      const patch = {
        data: { status: 'opened' },
        patched: 'status',
      };
      dispatch(oits.setIsLoading('openPhase'));
      const data = await ApiService.patch(`/api/v1/training-phases/${phaseGuid}`, patch)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(oits.setIsLoading('openPhase'));
      if (data) {
        dispatch(this.openPhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },
  reopenPhase(phaseGuid) {
    return async (dispatch) => {
      const patch = {
         reopen: true
      };
      dispatch(oits.setIsLoading('reopenPhase'));
      const data = await ApiService.patch(`/api/v1/training-phases/${phaseGuid}`, patch)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(oits.setIsLoading('reopenPhase'));
      if (data) {
        dispatch({
          phaseGuid,
          type: oitsCommitTypes.REOPEN_PHASE,
        })
        dispatch(notificationsActionsCreator.addSavedSuccessfully('Phase opened'));
      }
      return Promise.resolve();
    };
  },
  openPhaseSuccess(openPhaseResponse) {
    return (dispatch) => {
      dispatch(this.replaceOitTrainingPhase(openPhaseResponse.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Phase opened'));
    };
  },
  pushOitTrainingPhases(trainingPhases) {
    return {
      trainingPhases,
      type: oitsCommitTypes.PUSH_OIT_TRAINING_PHASES,
    };
  },
  replaceOitTrainingPhase(trainingPhase) {
    return {
      trainingPhase,
      type: oitsCommitTypes.REPLACE_OIT_TRAINING_PHASE,
    };
  },
  setIsAssigningFtoFor(isAssigningFtoFor) {
    return {
      isAssigningFtoFor,
      type: oitsCommitTypes.SET_OIT_IS_ASSIGNING_FTO_FOR,
    };
  },
  unassignFtoFromPhase(phaseGuid) {
    return async (dispatch) => {
      const url = `/api/v1/training-phases/${phaseGuid}/assign-fto`;
      dispatch(oits.setIsLoading('unassignFtoFromPhase'));
      const data = await ApiService.delete(url)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.resolve();
        });
      dispatch(oits.setIsLoading('unassignFtoFromPhase'));
      if (data) {
        dispatch(this.unassignFtoFromPhaseSuccess(data));
      }
      return Promise.resolve();
    };
  },
  unassignFtoFromPhaseSuccess(oitResponse) {
    return (dispatch) => {
      dispatch(this.replaceOitTrainingPhase(oitResponse.data));
    };
  },

  saveHasRiskAlerts(has_risk_alert, trainingPhaseGuid) {
    return (dispatch) => {
      return ApiPatch(`/api/v1/training-phases/${trainingPhaseGuid}`, {has_risk_alert})
        .then(() => {
          dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved'));
          dispatch({
            hasRiskAlert: has_risk_alert,
            trainingPhaseGuid,
            type: oitsCommitTypes.UPDATE_TRAINING_PHASE_HAS_RISK_ALERTS,
          })
        })
    }
  },

  savePhaseStartDate(scheduled_to, trainingPhaseGuid) {
    return (dispatch) => {
      return ApiPatch(`/api/v1/training-phases/${trainingPhaseGuid}`, {scheduled_to})
        .then(() => {
          dispatch(notificationsActionsCreator.addSavedSuccessfully('Changes saved'));
          dispatch({
            scheduledTo: scheduled_to,
            trainingPhaseGuid,
            type: oitsCommitTypes.UPDATE_PHASE_START_DATE,
          })
        })
    }
  }
};

export default oitsActionCreators;
